export function msToTime(duration) {
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);

  seconds = seconds < 10 ? '0' + seconds : seconds;

  return minutes + ':' + seconds;
}
